import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import Typography from '@/components/ui/typography';
import { CategoryContext } from '@/lib/CategoryContext';
import { useContext } from 'react';

const PaymentMethod = () => {
  const { paymentMethods } = useContext(CategoryContext);

  return (
    <Accordion type="single" collapsible>
      {paymentMethods.map((method, index) => (
        <AccordionItem key={index} value={method.name}>
          <AccordionTrigger className="px-2 bg-secondary">
            {method.name}
          </AccordionTrigger>
          <AccordionContent>
            <div className="flex flex-col items-center justify-center gap-2">
              <img className="size-60" src={method.qr_code} alt={method.name} />
              <Typography.Body className="border px-2 py-1">
                {method.upi_id}
              </Typography.Body>
            </div>
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export default PaymentMethod;
